// extracted by mini-css-extract-plugin
export default {"title":"_6b45c7d521","bld":"_8e01244703"};